import '../assets/NcEmptyContent-pSz7F6Oe.css';
import { n as e } from "../chunks/_plugin-vue2_normalizer-u6G_3nkj.mjs";
const s = {
  name: "NcEmptyContent",
  props: {
    /**
     * A header message about an empty content shown
     * @example 'No comments'
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Desription of the empty content
     * @example 'No comments yet, start the conversation!'
     */
    description: {
      type: String,
      default: ""
    }
  },
  computed: {
    hasName() {
      return this.name !== "";
    },
    /**
     * Check if a description is given as either property or slot
     */
    hasDescription() {
      return this.description !== "" || this.$slots.description?.[0];
    }
  }
};
var i = function() {
  var t = this, n = t._self._c;
  return n("div", { staticClass: "empty-content", attrs: { role: "note" } }, [t.$slots.icon ? n("div", { staticClass: "empty-content__icon", attrs: { "aria-hidden": "true" } }, [t._t("icon")], 2) : t._e(), t._t("name", function() {
    return [t.hasName ? n("span", { staticClass: "empty-content__name" }, [t._v(" " + t._s(t.name) + " ")]) : t._e()];
  }), t.hasDescription ? n("p", { staticClass: "empty-content__description" }, [t._t("description", function() {
    return [t._v(" " + t._s(t.description) + " ")];
  })], 2) : t._e(), t.$slots.action ? n("div", { staticClass: "empty-content__action" }, [t._t("action")], 2) : t._e()], 2);
}, a = [], o = /* @__PURE__ */ e(
  s,
  i,
  a,
  !1,
  null,
  "458108e7",
  null,
  null
);
const _ = o.exports;
export {
  _ as default
};
